<div class="reale-theme-style2 fs-6" fxLayout="column">
    <div fxLayout="column" class="wrapper">
        <header [configuration]="headerConfiguration"></header>
        <app-title [data]="titleData"></app-title>
    </div>
    <div class="policies" style="background-color: transparent">
        <app-policy-list></app-policy-list>
    </div>
</div>